import { gql } from '@apollo/client';

export const METER_AGGREGATED_MEASUREMENTS = gql`
  query MeterAggregatedMeasurements($installationId: UUID!, $input: GetAggregateMeasurementsRequestInput!) {
    meterAggregatedMeasurements(installationId: $installationId, input: $input) {
      data {
        aggregateVectorMeasurements {
          type
          range
          values
          index
          tariff
        }
      }
      error {
        errorCode
        description
      }
    }
  }
`;

export const PERSISTED_METER_AGGREGATED_MEASUREMENTS = gql`
  query PersistedMeterAggregatedMeasurements($installationId: UUID!, $input: GetPersistedAggregateMeasurementsRequestInput!) {
    persistedMeterAggregatedMeasurements(installationId: $installationId, input: $input) {
      data {
        __typename
        from
        to
        oldestAtUtc
        items {
          __typename
          dateAtUtc
          measurements
        }
      }
      error {
        errorCode
        description
      }
    }
  }
`;

export const METER_COMMON_MEASUREMENTS = gql`
  query MeterCommonMeasurements($installationId: UUID!, $input: GetCommonMeasurementsRequestInput!) {
    meterCommonMeasurements(installationId: $installationId, input: $input) {
      data {
        vectorMeasurements {
          type
          value
          index
        }
        scalarMeasurements {
          type
          value
        }
      }
      error {
        errorCode
        description
      }
    }
  }
`;

export const MEASUREMENT_MAP = gql`
  query MeasurementMap {
    measurementMap {
      meter {
        kind
        scalars {
          type
          value
        }
        vectors {
          type
          value
        }
        aggregates {
          type
          value
        }
      }
      optimizer {
        kind
        scalars {
          type
          value
        }
        vectors {
          type
          value
        }
        aggregates {
          type
          value
        }
      }
      cacheInfo {
        hash
      }
    }
  }
`;

export const DYNAMIC_MARKET_PRICES_WITH_BUCKETS = gql`
  query DynamicMarketPricesWithBuckets {
    dynamicMarketPricesWithBuckets {
      bucketInfos {
        fromPriceInKWh
        toPriceInKWh
      }
      days {
        day
        records {
          time
          priceInMWh
          priceInkWh
          startingHour
        }
      }
    }
  }
`;

export const SEASON_PRICES = gql`
  query SeasonPrices($installationId: UUID!) {
    seasonPrices(installationId: $installationId) {
      summer {
        from
        to
        workingDayEntries {
          time
          priceInMWh
          priceInkWh
          startingHour
        }

        offFromWorkDayEntries {
          time
          priceInMWh
          priceInkWh
          startingHour
        }
      }
      winter {
        from
        to
        workingDayEntries {
          time
          priceInMWh
          priceInkWh
          startingHour
        }

        offFromWorkDayEntries {
          time
          priceInMWh
          priceInkWh
          startingHour
        }
      }
      staticHolidays
      movableHolidays
      bucketInfos {
        fromPriceInKWh
        toPriceInKWh
      }
    }
  }
`;
